import React from 'react';
import { NavLink } from 'react-router-dom';
// import {
//     Nav,
//     NavLink,
//     Bars,
//     NavMenu,
//     NavBtn,
//     NavBtnLink,
// } from './NavbarElements';

const Navbar = () => {
    return (
        <>

            <nav>
                <div className='navcontainer' >
                    <div className='logoContainer navM'>
                        <NavLink exact to="/" className='logo'> GABRIX </NavLink>
                    </div>

                    <div className='menuContainer navM'>
                        <ul>
                            <li>
                                <NavLink className={({ isActive }) => {
                                    const linkClasses = [];
                                    if (isActive) linkClasses.push('active-link');
                                    return linkClasses.join(" ");
                                }}
                                    exact to="/" >
                                    Home
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className={({ isActive }) => {
                                    const linkClasses = [];
                                    if (isActive) linkClasses.push('active-link');
                                    return linkClasses.join(" ");
                                }}
                                    exact to="/about">
                                    About
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className={({ isActive }) => {
                                    const linkClasses = [];
                                    if (isActive) linkClasses.push('active-link');
                                    return linkClasses.join(" ");
                                }}
                                    exact to="/skills">
                                    Skills
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className={({ isActive }) => {
                                    const linkClasses = [];
                                    if (isActive) linkClasses.push('active-link');
                                    return linkClasses.join(" ");
                                }}
                                    exact to="/services">
                                    Services
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className={({ isActive }) => {
                                    const linkClasses = [];
                                    if (isActive) linkClasses.push('active-link');
                                    return linkClasses.join(" ");
                                }}
                                    exact to="/portfolio">
                                    Portfolio
                                </NavLink>
                            </li>
                            <li>
                                <NavLink className={({ isActive }) => {
                                    const linkClasses = [];
                                    if (isActive) linkClasses.push('active-link');
                                    return linkClasses.join(" ");
                                }}
                                    exact to="/contact">
                                    Contact
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                </div>
            </nav>

        </>
    );
};

export default Navbar;

